import { ReactNode } from "react";
import { Check, CircleNotch } from "@phosphor-icons/react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

export type TProgressStepStatus = "done" | "active" | "pending";

type TProgressStepProps = {
  status: TProgressStepStatus;
  children: ReactNode;
  className?: string;
};

export function ProgressStep({ status, children, className }: TProgressStepProps) {
  return (
    <div className={cn("flex w-full items-start gap-[8px]", className)}>
      <span className="flex shrink-0 items-center pt-[3px]">
        {status === "done" ? (
          <Check size={16} weight="bold" className="text-[#40AB6D]" />
        ) : (
          <CircleNotch
            size={16}
            weight="bold"
            className={cn(
              status === "active" ? "animate-spin text-innoveraZinc-900" : "text-innoveraZinc-300"
            )}
          />
        )}
      </span>
      <div
        className={cn(
          "min-w-0 flex-1 text-[14px] leading-[22px]",
          status === "pending" ? "text-innoveraZinc-300" : "text-innoveraZinc-900"
        )}
      >
        {children}
      </div>
    </div>
  );
}
